<div class="form-wrap"
     cdkDrag
>
    <form [formGroup]="loginForm"
          class="form"
    >
        <div class="form-title"
             cdkDragHandle
        >
            <img [src]="'../../../../assets/images/logos/pro-business.svg'">
        </div>
        <mat-form-field style="width: 100%;"
                        class="form-field-cs"
        >
            <lucide-icon matPrefix
                         name="mail"
                         class="form-field-icon"
            ></lucide-icon>
            <mat-label>{{ 'LOGIN.ENTER_EMAIL' | translate }}</mat-label>
            <input matInput
                   formControlName="email"
                   autocomplete="on"
                   autocomplete="email"
                   data-cy="email-input"
            >
            <mat-error *ngIf="email?.errors?.['required']"
                       data-cy="email-error-required"
            >
                {{ 'VALIDATION.REQUIRED' | translate }}
            </mat-error>
            <mat-error *ngIf="email?.errors?.['email']"
                       data-cy="email-error-validation"
            >
                {{ 'VALIDATION.EMAIL' | translate }}
            </mat-error>
        </mat-form-field>
        <mat-form-field class="form-field-cs"
                        autocomplete="on"
                        autocomplete="password"
        >
            <mat-label>{{ 'LOGIN.ENTER_PASS' | translate }}</mat-label>
            <lucide-icon matPrefix
                         name="lock"
                         class="form-field-icon"
            ></lucide-icon>
            <lucide-icon matSuffix
                         name="eye"
                         [class.hide-password]="hidePassword"
                         class="form-field-icon"
                         data-cy="password-hide"
                         (click)="hidePassword = !hidePassword"
            ></lucide-icon>
            <input matInput
                   formControlName="passwd"
                   [type]="hidePassword ? 'password' : 'text'"
                   data-cy="password-input"
            >
            <mat-error *ngIf="password?.errors?.['required']"
                       data-cy="password-error-required"
            >
                {{ 'VALIDATION.REQUIRED' | translate }}
            </mat-error>
        </mat-form-field>
        <div class="form-button-group">
            <button mat-button
                    (click)="authenticateUser()"
                    data-cy="login-submit"
                    [disabled]="loginForm.invalid||formState==='Submitting'"
                    class="form-button-group-button submit"
            >
                {{ 'LOGIN.ENTER2' | translate }}
            </button>
            <button mat-button
                    (click)="goToActivateAccount()"
                    data-cy="goToActivateAccount"
                    class="form-button-group-button sign-up"
            >
                {{ 'ACTIVATE.ACTIVATE' | translate }}
            </button>
        </div>
        <a class="form-button-group-button restore"
           href=""
           target="_blank"
        >
            {{ 'LOGIN.RESTORE' | translate }}
        </a>
    </form>
</div>
